/* istanbul ignore file */
/* eslint-disable react/prop-types */
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Redirect, useLocation } from 'react-router-dom';
import { selectSessionInformation } from '../../../../redux/slices/sessionSlice';
import DeviceDetailsTable from '../DeviceDetailsTable';
import DeviceDetailsHeader from '../DeviceDetailsHeader/DeviceDetailsHeader';
import {
  fetchSingleDevice,
  selectSingleDevice,
  updateDeviceName,
} from '../../../../redux/slices/singleDeviceSlice/singleDeviceSlice';
import DeviceSensors from '../DeviceSensorsDashboard/DeviceSensors/DeviceSensors';
import MaxDeviceSensors from '../DeviceSensorsDashboard/MaxDeviceSensors/MaxDeviceSensors';
import { RaaRoles, sessionUserHasRolePrivileges } from '../../../../utility/SecurityRules';

function DeviceDetailsLayout() {
  const location = useLocation();
  const dispatch = useDispatch();
  const device = useSelector(selectSingleDevice);
  const scalePreferences = useSelector(selectSessionInformation);
  const deviceLatestFirmware = location.state ? location.state.latestFirmware : null;
  const deviceImages = require.context('../../../../assets/ra-device-images', false, /\.(gif|png|jpe?g)$/);
  const { activeSubscription } = useSelector(selectSessionInformation);
  const hasWriteAccess = sessionUserHasRolePrivileges(
    activeSubscription,
    [RaaRoles.MANAGER, RaaRoles.ADMIN],
  );

  const getDeviceImage = (deviceType) => {
    try {
      return deviceImages(`./${deviceType}.gif`);
    } catch (error) {
      // todo: return a default image or null if the image doesn't exist
      return null;
    }
  };

  const saveDeviceName = (newName) => {
    dispatch(updateDeviceName({
      deviceId: device.general.id,
      name: newName,
    }))
      .unwrap()
      .then(() => {
        // setDeviceName(newName);
        dispatch(fetchSingleDevice({ deviceId: device.general.id }));
      })
      .catch((error) => {
        // eslint-disable-next-line no-console
        console.error('Error updating device name:', error);
        // Handle error appropriately
      });
  };

  if (!device) {
    return (
      <Redirect to="/s/devices" />
    );
  }

  if (!device.general.type.startsWith('RA')) {
    window.location.href = `/devices/${device.general.id}`;
    return null;
  }

  return (
    <>
      <DeviceDetailsHeader
        deviceInfo={device.general}
        handleSubmitNameChange={saveDeviceName}
        isPublic={!hasWriteAccess}
      />
      {/* Main Device Info Section */}
      <div className="row">
        <DeviceDetailsTable
          deviceInfo={device.general}
          latestFirmware={deviceLatestFirmware}
            /* istanbul ignore next */
          deviceImage={getDeviceImage(device.general.type)}
        />
      </div>

      {device.general.type === 'RAMAX'
        ? (
          <MaxDeviceSensors
            sensors={device.sensors}
            deviceInfo={device.general}
            scalePreferences={scalePreferences}
            isReadOnly={!hasWriteAccess}
          />
        )
        : (
          <DeviceSensors
            sensors={device.sensors}
            deviceInfo={device.general}
            scalePreferences={scalePreferences}
            isReadOnly={!hasWriteAccess}
          />
        )}
    </>
  );
}

export default DeviceDetailsLayout;
